// **  Initial State
const initialState = {
  isLoading: false,
  data: null,
}

export const customers = (state = initialState, action) => {
  switch (action.type) {
    case 'LOADER_START':
      return {
        ...state,
        isLoading: true,
      }
    case 'LOADER_STOP':
      return {
        ...state,
        isLoading: false,
      }
    case 'SET_CUSTOMERS':
      return {
        ...state,
        data: action.payload,
      }
    case 'CLEAR_CUSTOMERS':
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}
